import { useState, useEffect, useRef, forwardRef } from "react";
import DividerLine from "ui/crfs/divider_line";
import styles from "./date_time.module.css";
import DateTimeUI from "./components/date_time_ui";
import DataCompleteChangeModal from "ui/crfs/data_complete_change_modal";
import EntryRuleOverrideModal from "ui/crfs/entry_rule_override_modal";
import { cloneDeep } from "lodash";
import ElementMenu from "ui/crfs/element_menu";
import moment from "moment-timezone";
import LoadingButton from "@mui/lab/LoadingButton";
import ElementTitle from "ui/crfs/element_title";

let tempStorage = null;

export default function DateTime(props) {
  const { field, onUpdate, enableQuery, title, first_randomized_on } = props;
  const [localVal, setLocalVal] = useState((field && field.value_obj) || {});
  const [showingCompleteChangeModal, setShowingCompleteChangeModal] = useState(false);
  const [dataChange, setDataChange] = useState(false);
  const [showingEntryOverrideModal, setShowingEntryOverrideModal] = useState(false);

  const forwardDateRef = useRef(null);
  useEffect(() => {
    setLocalVal((field && field.value_obj) || {});
    tempStorage = (field && field.value_obj) || {};
  }, [field.value_obj]);

  const commonUpdateValueActions = (value_obj, reason = null) => {
    if (tempStorage.value === value_obj.value && tempStorage.value2 === value_obj.value2) {
      return;
    }
    let obj = {
      data_id: field?.value_obj?.data_id || null,
      flags: field?.value_obj?.flags || null,
      value: value_obj.value,
      value2: value_obj.value2,
      value_name: field.value_name || null,
      value2_name: field.value2_name || null,
      reason,
      deviation: field?.value_obj?.deviation || null,
    };
    onUpdate(obj);
    tempStorage = value_obj;
    setDataChange(false);
  };
  const acceptTempStorage = (reason) => {
    commonUpdateValueActions(localVal, reason);
    tempStorage = localVal;
    setShowingCompleteChangeModal(false);
    setShowingEntryOverrideModal(false);
    setDataChange(false);
  };

  const closeModal = () => {
    setShowingCompleteChangeModal(false);
    setShowingEntryOverrideModal(false);
    setLocalVal(tempStorage);
    setDataChange(false);
  };

  // const updateValue = (value_obj) => {
  //   if (crfStatus === "data_complete") {
  //     tempStorage = cloneDeep(localVal);
  //     setLocalVal(value_obj);
  //     setShowingCompleteChangeModal(true);
  //   }
  //   setLocalVal(value_obj);
  //   onUpdate(value_obj);
  // };

  const updateValue = (error_override = false, value_obj = null) => {
    if (entry_rule_error() && !error_override) {
      if (field.entry_rule_override) {
        setShowingEntryOverrideModal(true);
      } else {
        setLocalVal(tempStorage);
        setDataChange(false);
      }
    } else {
      commonUpdateValueActions(value_obj || localVal);
      setDataChange(false);
    }
  };

  const entry_rule_error = (value = null) => {
    let _value = value || localVal;
    let error = false;
    if (dataChange || value) {
      field?.entry_rules?.some((rule) => {
        if (rule.rule_type === "not_future") {
          if (moment(moment().format("yyyy-MM-DD")).diff(moment(_value.value), "days") < 0) {
            error = `Must be in the past.`;
            return error;
          }
        } else if (rule.rule_type === "not_past") {
          if (moment(moment().format("yyyy-MM-DD")).diff(moment(_value.value), "days") > 0) {
            error = `Must be in the future.`;
            return error;
          }
        } else if (rule.rule_type === "after_randomization" && first_randomized_on) {
          if (
            moment(`${_value.value}`).diff(moment(moment.utc(first_randomized_on)).tz(moment.tz.guess()), "days") < 0
          ) {
            error = `Must be greater than or equal to ${moment.utc(first_randomized_on).tz(moment.tz.guess()).format("yyyy-MM-DD")}`;
            return error;
          }
        } else if (rule.rule_type === "before_randomization" && first_randomized_on) {
          if (
            moment(`${_value.value}`).diff(moment(moment.utc(first_randomized_on)).tz(moment.tz.guess()), "days") > 0
          ) {
            error = `Must be less than or equal to ${moment.utc(first_randomized_on).tz(moment.tz.guess()).format("yyyy-MM-DD")}`;
            return error;
          }
        }
      });
    }

    return error;
  };

  const currentValueDisplay = `${localVal.value} ${localVal.value2}`;

  return (
    <div className={styles.outer_wrapper}>
      <div className={styles.input_flex}>
        <div className={styles.left_split}>
          {enableQuery ? <ElementTitle required={field.required} title={title} /> : <div>{title}</div>}
        </div>
        <div className={[styles["right-split"], styles.date_entry].join(" ")}>
          <div className={styles.flex_column}>
            <div className={styles.flex_row}>
              <DateTimeUI
                {...props}
                field={{ ...field, value_obj: localVal }}
                onUpdate={(value, key) => {
                  if (!dataChange) {
                    tempStorage = { ...localVal };
                    setDataChange(true);
                  }
                  if (value) {
                    setLocalVal(value);
                    if (
                      value?.value === null ||
                      (["19", "20"].includes(value?.value?.slice(0, 2)) && !entry_rule_error(value))
                    ) {
                      updateValue(false, value);
                    }
                  }

                  // if (key !== "date" || value?.value === null) {
                  //   updateValue(false, value);
                  // }
                }}
                onDateTimeBlur={() => updateValue()}
                key={props.field.id}
                date_position={"value"}
                time_position={"value2"}
                disableFuture={!!field?.entry_rules?.find((r) => r.rule_type === "not_future") || false}
                disablePast={!!field?.entry_rules?.find((r) => r.rule_type === "not_past") || false}
              />

              <div className={styles.audit_icon}>
                <ElementMenu {...props} />
              </div>
            </div>
            <div className={styles.flex_row}>
              {entry_rule_error().constructor === String ? (
                <div className={styles.input_flex}>
                  <div className={styles.error}>{entry_rule_error()}</div>
                  {field?.entry_rule_override ? (
                    <LoadingButton
                      variant="outlined"
                      loading={false}
                      onClick={() => updateValue()}
                      sx={{
                        fontSize: 14,
                        padding: "2px",
                        paddingLeft: "10px",
                        paddingRight: "10px",
                        marginLeft: "10px",
                      }}
                    >
                      Save Anyway
                    </LoadingButton>
                  ) : null}
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>

      <DividerLine />
      <DataCompleteChangeModal isOpen={showingCompleteChangeModal} close={closeModal} onYes={acceptTempStorage} />
      <EntryRuleOverrideModal isOpen={showingEntryOverrideModal} close={closeModal} onYes={acceptTempStorage} />
    </div>
  );
}
